import styled from '@emotion/styled';

import { FONT, COLORS, SPACING } from '@zola/zola-ui/src/styles/emotion';

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 474px;
  padding: ${SPACING.MD};
  text-align: center;
  width: 100%;
`;

export const Title = styled.h3`
  ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_REGULAR)};
  color: ${COLORS.BLACK};
  font-family: ${FONT.FONT_FAMILY_SERIF};
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  margin-bottom: ${SPACING.SM};
  margin-top: 22px;
`;

export const Subtitle = styled.div`
  ${FONT.textSizeCompact(FONT.FONT_SIZE_SMALL)};
  color: ${COLORS.BLACK};
  font-family: ${FONT.FONT_FAMILY_SANS_SERIF};
  margin-bottom: 28px;
`;
